// 단말보호 2뎁스는 단말보호로, 탭 루트(1뎁스)는 홈으로, 홈은 앱을 종료한다.
// 비상연락처 등록·편집과 발송내역은 연락처 목록으로 돌아간다.

const TAB_ROOTS = ["/device", "/family", "/mypage", "/magazine/financial-magazine"]

let deviceHubPosition = null
let viaPop = false
let redirecting = false
let exitMethod = undefined

const normalize = (path) => {
  const value = appPath(path)
  if (value.length > 1 && value.endsWith('/')) return value.slice(0, -1)
  return value
}

export const isHomePath = (path) => normalize(path) === '/main'

export const isDeviceHubPath = (path) => normalize(path) === '/device'

export const isDeviceChildPath = (path) => normalize(path).startsWith('/device/')

export const isTabRootPath = (path) => TAB_ROOTS.includes(normalize(path))

export const isEmergencyContactPath = (path) => normalize(path) === '/device/emergency-contact'

export const isMessageHistoryPath = (path) => normalize(path) === '/device/message-history'

export const isEmergencyFormRoute = (route) =>
  isEmergencyContactPath(route?.path) && String(route?.query?.view || '') === 'form'

export const isEmergencyListRoute = (route) =>
  isEmergencyContactPath(route?.path) && String(route?.query?.view || '') !== 'form'

export const rememberDeviceHub = (route) => {
  if (!import.meta.client || !isDeviceHubPath(route?.path)) return
  const position = window.history.state?.position
  if (typeof position === 'number') deviceHubPosition = position
}

const exitNativeApp = async () => {
  const pk = await ensurePk()
  if (!pk?.available) return false
  if (exitMethod === undefined) {
    try {
      const info = await pk.call("getBridgeInfo", {})
      const methods = info?.methods || []
      exitMethod = methods.find((name) => /(exit|finish|terminate|closeApp)/i.test(name)) || null
    } catch {
      exitMethod = null
    }
  }
  const bridge = window.SafePhoneBridge
  if (!exitMethod && bridge) {
    const direct = ["exitApp", "finish", "closeApp", "close"].find((name) => typeof bridge[name] === "function")
    if (direct) {
      bridge[direct]()
      return true
    }
  }
  if (!exitMethod) return false
  try {
    await pk.call(exitMethod, {})
    return true
  } catch (error) {
    console.error("[home] 앱 종료 실패", error)
    return false
  }
}

export const exitDeviceSection = () => {
  if (!import.meta.client) return navigateTo('/device')
  const position = window.history.state?.position
  if (typeof deviceHubPosition === 'number' && typeof position === 'number' && position > deviceHubPosition) {
    redirecting = true
    window.history.go(deviceHubPosition - position)
    return
  }
  return navigateTo('/device', { replace: true })
}

export const installDeviceSectionBack = (router) => {
  if (!import.meta.client) return
  window.addEventListener('popstate', () => {
    viaPop = true
  })
  rememberDeviceHub(router.currentRoute.value)
  router.afterEach((to, from) => {
    rememberDeviceHub(to)
    if (!viaPop) return
    viaPop = false
    if (redirecting) {
      redirecting = false
      return
    }
    if (isHomePath(from.path)) {
      // 브라우저에서는 그냥 이전 기록으로 간다. 앱에서만 종료한다.
      void (async () => {
        const pk = await ensurePk()
        if (!pk?.available) return
        await exitNativeApp()
        if (!isHomePath(router.currentRoute.value.path)) navigateTo("/main", { replace: true })
      })()
      return
    }
    if (isTabRootPath(from.path)) {
      if (!isHomePath(to.path)) navigateTo("/main", { replace: true })
      return
    }
    // 홈에서 바로 연 화면은 홈에 머문다. 여기서 탭으로 다시 보내면 홈이 잠깐 보였다가 돌아간다.
    if (isHomePath(to.path)) return
    if (!isDeviceChildPath(from.path)) return
    if (isEmergencyFormRoute(from)) {
      if (!isEmergencyListRoute(to)) navigateTo('/device/emergency-contact', { replace: true })
      return
    }
    // 비상연락처에서 연 발송내역은 단말보호가 아니라 연락처 목록으로 돌아간다.
    if (isMessageHistoryPath(from.path) && isEmergencyContactPath(to.path)) return
    if (isDeviceHubPath(to.path)) return
    exitDeviceSection()
  })
}
